import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ApiService } from '../services/api.service';
import { StateService } from '../services/state.service';
import { VehicleService } from '../services/vehicle.service';
import { map,catchError } from 'rxjs/operators';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @ViewChild('pswd') passwordField;
  
  constructor(private authSvc: AuthService, private apiSvc: ApiService, private stateSvc: StateService,
	private vehicleSvc: VehicleService
  ) { }
  
  // get current full date of today
  currentDate = new Date();
  // get current Year to be shown
  currentYear = this.currentDate.getFullYear();
  // default username value
  username = '';
  password = '';
  error = '';
  // either to show or hide sign up button
  isValidForm = false;
  debugMode = false;

  ngOnInit(): void {
	if(localStorage.getItem('userNm')){
		// if the machine detected any login previously, use back and fill up username same as before
		this.username = localStorage.getItem('userNm');
	}
  }
  
  /**
   * Typing event for field username & password
   * Set Sign In Button to visible if user filled up both username & password, else it will hide
   */
  toShowHideButton(){
	// to check all fields had been filled up, default hide the button
	let filledUp = false;
	if(this.username != '' && this.password != ''){
		// only show button if both fields are filled up
		filledUp = true;
	}
	// set global Variable either to show or hide Sign In button
	this.isValidForm = filledUp;
  }
  
  /**
   * Function to handle login when user click on button Sign In
   */
  login(){
	// clear error msg first
	this.error = '';
	// remember username in localStorage, so next time login can auto fill up same username
	localStorage.setItem('userNm', this.username);
	
	if(!this.debugMode){
		// call function in AuthService, to check credential with backend API
		this.authSvc.login(this.username, this.password)
		.subscribe((user:any) => {
			if(user?.owner){
				if(user.superuser){
					this.callZonePois(user);
				}else{
					this.vehicleSvc.getVehicles(user.owner).subscribe((vhc) => {
						this.authSvc.storeUserLocally(user);
						if(vhc?.length > 0){
							// set flag is_logged_in
							this.stateSvc.setIsLoggedIn(true);
							// redirect to map page
							this.apiSvc.navigateInternal('map');
							this.callZonePois(user);
						}
					},(err) => {
						if(!user.superuser){
							this.loginOut();
						}
					});
				}
			}else{
				// this.loginOut();
			}
		},
		(err) => {
			// this.loginTracksolid(this.username);
			console.log('err',err)
			this.error = err;
			this.stateSvc.setIsLoggedIn(false);
			this.password = '';
			this.isValidForm = false;
			this.passwordField.nativeElement.focus();
			// this.loginOut();
		});
	}else{
		let user:any = {};
		user.username = this.username;
		user.owner = this.username;
		user.hash = this.authSvc.hashBlowfish(this.username);
		
		// init empty zone & POI before call backend API
		user.zones = [];
		user.pois = [];
		// store session locally
		sessionStorage.setItem('user', JSON.stringify(user));
		// set flag is_logged_in
		this.stateSvc.setIsLoggedIn(true);
		// redirect to map page
		this.apiSvc.navigateInternal('map');
	}
  }

  callZonePois(user){
	this.authSvc.getUserZones(this.username)
	.subscribe((zones:any) => {
		user.zones = zones;
		this.authSvc.getUserPois(this.username)
		.subscribe((pois:any) => {
			user.pois = pois;
			// stote user local
			this.authSvc.storeUserLocally(user);
			// set flag is_logged_in
			this.stateSvc.setIsLoggedIn(true);
			// redirect to map page
			this.apiSvc.navigateInternal('map');
		});
	});
  }

  loginOut(){
	this.authSvc.getCredentialData()
	.subscribe((str:any) => {
		this.authSvc.getOutUsers(this.username, str?.collection_keys?.master, str?.collection_keys?.base_url)
		.subscribe((user:any) => {
			if(user?.username){
				// stote user local
				this.authSvc.storeUserLocally(user);
				this.vehicleSvc.getUsersVehicles()
				.subscribe((uvhcls:any) => {
					if(uvhcls?.length > 0){
						let dataUvhsc:any = [];
						uvhcls.forEach((uvhc:any) => {
							dataUvhsc.push(uvhc.terminalNo);
						})
						this.stateSvc.setUsersVehicleIds(dataUvhsc);
					}
					// set flag is_logged_in
					this.stateSvc.setIsLoggedIn(true);
					// redirect to map page
					this.apiSvc.navigateInternal('map');
				});
			}
		},
		(err) => {
			// console.log('err',err)
			// this.error = err;
			// this.stateSvc.setIsLoggedIn(false);
			// this.password = '';
			// this.isValidForm = false;
			// this.passwordField.nativeElement.focus();
			this.loginTracksolid(this.username);
		});
	})
  }

  loginTracksolid(username){
	this.authSvc.getAccessTokenTrack()
	.subscribe((result) => {
		if(result?.code == 0){
			let tokenInfo:any = result?.result;
			tokenInfo.token = result?.result?.accessToken;
			tokenInfo.token_expiry = this.authSvc.generateExpiryTracksoliToken(result?.result);
			localStorage.setItem('tracksolidtoken', JSON.stringify(tokenInfo));

			this.authSvc.getTrackSolidUsers(username)
			.subscribe((user) => {
				if(user?.username){
					// stote user local
					this.authSvc.storeUserLocally(user);

					let accounts = this.stateSvc.getTrackSolidAccounts();
					const requests = accounts.map((account) =>
						this.vehicleSvc.getUsersTracksolidVehicles(account.account)
						.pipe(
							map((vehicles: any[]) =>
								vehicles.map(vehicle => ({
									...vehicle,
									tracksolidAccount: account.account,
									tracksolidUserId: account.userId
								}))
							)
						)
					);
					let vehicleGroups:any = [];
					forkJoin(requests).subscribe({
						next: (uvhcls: any[]) => {

							if(uvhcls?.length > 0){
								let dataUvhsc:any = [];
								let objByhcl:any = {};
								uvhcls.forEach((uvhc:any) => {
									let imeiNo = uvhc.imei;
									dataUvhsc.push({imeiNo: uvhc});

									if (vehicleGroups.indexOf(uvhc.deviceGroup) == -1) {
										vehicleGroups.push(uvhc.deviceGroup);
									}

									objByhcl[uvhc.imei] = uvhc;
								})
								this.stateSvc.setUsersVehicleIds(dataUvhsc);
							}
							// set flag is_logged_in
							this.stateSvc.setIsLoggedIn(true);
							// redirect to map page
							this.apiSvc.navigateInternal('map');
						},
						error: (error) => {
							console.error('Vehicle API error:', error);
						}
					});


					// this.vehicleSvc.getUsersTracksolidVehicles()
					// .subscribe((uvhcls:any) => {
					// 	if(uvhcls?.length > 0){
					// 		let dataUvhsc:any = [];
					// 		let vehicleGroups:any = [];
					// 		let objByhcl:any = {};
					// 		uvhcls.forEach((uvhc:any) => {
					// 			let imeiNo = uvhc.imei;
					// 			dataUvhsc.push({imeiNo: uvhc});

					// 			if (vehicleGroups.indexOf(uvhc.deviceGroup) == -1) {
					// 				vehicleGroups.push(uvhc.deviceGroup);
					// 			}

					// 			objByhcl[uvhc.imei] = uvhc;
					// 		})
					// 		this.stateSvc.setVehicleGroups(vehicleGroups);
					// 		this.stateSvc.setUsersVehicleObjIds(objByhcl);
					// 		this.stateSvc.setUsersVehicleIds(dataUvhsc);
					// 	}
					// 	// set flag is_logged_in
					// 	this.stateSvc.setIsLoggedIn(true);
					// 	// redirect to map page
					// 	this.apiSvc.navigateInternal('map');
					// });
				}
			}, (err) => {
				console.log('err',err)
				this.error = err;
				this.stateSvc.setIsLoggedIn(false);
				this.password = '';
				this.isValidForm = false;
				this.passwordField.nativeElement.focus();		
			})
		}
		
	}, (err) => {
		console.log('err',err)
		this.error = err;
		this.stateSvc.setIsLoggedIn(false);
		this.password = '';
		this.isValidForm = false;
		this.passwordField.nativeElement.focus();
	});
  }
}
